import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { Divider, TextButton, space } from 'folio-common-components';
import { formatters } from 'folio-common-utils';
import * as React from 'react';
import type { CompanyOwner } from '../../state/editor';
import { nameFallback } from '../../utils';
import { Box } from '../box';

const Description = styled.p`
  margin: 0;
`;

type Props = {
  owner: CompanyOwner;
  onClick: () => void;
};

export const SingleCompanyOwnerSummary: React.FC<Props> = props => {
  return (
    <Box>
      <div
        css={css`
          display: flex;
          justify-content: space-between;
          ${space([16], 'gap')};
        `}
      >
        Eierselskapet
      </div>

      <Divider css={space([16], 'margin-vertical')} />
      <div>
        <b css={space([8], 'margin-right')}>
          {nameFallback(props.owner.item.name)}
        </b>{' '}
        <TextButton onClick={props.onClick}>Rediger info</TextButton>
      </div>

      <Description css={space([4], 'margin-top')}>
        Ved{' '}
        {formatters.joinRunningTextList(
          props.owner.signatories.map(e => e.name),
        )}
      </Description>
    </Box>
  );
};
